import { PaymentServicePriceVersionEntity } from '../../../payments/payment-template';
import { PaymentServiceUserAllocation } from '../payment-service-user-allocation';
import { PaymentServiceWithPriceListResponse } from '../../../payments/payment-service-with-price-list-response';
import { SettingsBranches } from '../../../settings/branches/settings-branches';
import { ProgramMetadata } from '../../../programs/program-metadata';
import { BaseEntity } from '../../../base-entity';

export interface PaymentBankTransferDetailsEntity extends BaseEntity {
  id: number;
  paymentId: number;
  bankNumber: string;
  branchNumber: string;
  accountNumber: string;
  transferDate: Date;
  referenceId: string;
}

export enum CheckStatusType {
  PENDING = 'pending',
  DEPOSITED = 'deposited',
  CLEARED = 'cleared',
  BOUNCED = 'bounced',
  CANCELLED = 'cancelled',
  EXPIRED = 'expired',
}

export const getCheckStatusDisplayText = (statusCheck: CheckStatusType) => {
  switch (statusCheck) {
    case CheckStatusType.BOUNCED:
      return 'חזר';
    case CheckStatusType.CANCELLED:
      return 'בוטל';
    case CheckStatusType.CLEARED:
      return 'נוקה בהצלחה';
    case CheckStatusType.DEPOSITED:
      return 'הופקד';
    case CheckStatusType.EXPIRED:
      return 'פג תוקף';
    case CheckStatusType.PENDING:
      return 'ממתין לאישור';
  }
};

export interface PaymentCheckEntity extends BaseEntity {
  id: number;
  paymentId: number;
  amount?: number | null;
  itemAmount: number | null;
  bankNumber: string;
  branchNumber: string;
  accountNumber: string;
  checkStatus: CheckStatusType;
  updatedAt: Date | null;
  updatedBy: number | null;
  updatedByFirstName: string | null;
  updatedByLastName: string | null;
  dueDate: Date;
  referenceId: string;
}

export interface PaymentScholarshipEntity extends BaseEntity {
  id: number;
  paymentId: number;
  scholarshipId: number;
  studentScholarshipId: number;
  scholarshipSum?: number;
  consumeSum?: number;
  studentScholarshipsStatus?: string;
  funderId?: number;
  funderName?: string;
}

export interface PaymentCreditCardDetailsEntity extends BaseEntity {
  id: number;
  paymentId: number;
  creditCardClearanceId: number;
  installmentNumber: number | null;
  amount: number;
}

export interface UserPayment extends BaseEntity {
  id: number;
  userAllocationId: number;
  paymentAmount: number;
  paymentDate: string; // ISO timestamp
  paymentMethodType: PaymentMethodsDb;
  invoiceUrl: string;
  paymentReferenceType: PaymentReferenceType | null;
  parentId: number | null;
  checks?: PaymentCheckEntity[];
  paymentDetails?:
    | PaymentBankTransferDetailsEntity
    | PaymentCheckEntity
    | PaymentScholarshipEntity
    | PaymentCreditCardDetailsEntity;
}

export interface UserPaymentWithItemPrice extends UserPayment {
  itemAmount: number;
  itemId: number;
  userAllocationId: number;
}

export type UserPaymentServiceWithPriceList =
  PaymentServiceWithPriceListResponse & {
    currentPrices: PaymentServicePriceVersionEntity;
    allocations: PaymentServiceUserAllocationDetails;
    userPayments: UserPaymentWithItemPrice[];
    planIds: number[];
    bankTransferInstallmentPlanIds: number[];
  };

export interface PaymentServiceUserAllocationDetails {
  allocationEntity: PaymentServiceUserAllocation;
  branch: SettingsBranches;
  programEntity: ProgramMetadata;
  userPayments: UserPaymentEntity[];
}

export interface UserPaymentEntity extends BaseEntity {
  id: number;
  userAllocationId: number;
  paymentAmount: number;
  paymentDate: Date;
  paymentMethodType: PaymentMethodsDb;
  paymentStatus: PaymentStatusType;
  paymentReferenceType: PaymentReferenceType | null;
  parentId: number | null;
}

export enum PaymentReferenceType {
  REVERSAL = 'reversal',
  INSTALLMENT = 'installment',
}

export enum PaymentStatusType {
  SUCCESS = 'success',
  STANDING = 'standing',
  CANCEL = 'cancel',
}

export enum PaymentMethodsDb {
  CreditCard = 'credit_card',
  Cash = 'cash',
  Discount = 'discount',
  BankTransfer = 'bank_transfer',
  Scholarship = 'scholarship',
  Check = 'check',
}
